import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../MuroEditorLoadableWrapper';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const LoadableEditor = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "muro_editor" */ './Mobile')));
const MobileLoadable = (props)=>{
    return /*#__PURE__*/ React.createElement(EditorLoadableWrapper, null, /*#__PURE__*/ React.createElement(LoadableEditor, props));
};
MobileLoadable.displayName = 'MobileLoadable';
export default MobileLoadable;

//# sourceMappingURL=MobileLoadable.js.map